import React from 'react';
import { FlameIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_CURRENCY, PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerItems } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="oferta" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-116" data-mp="ifb3de0j4y04">
      <p className="flex items-center justify-center gap-1.5 text-[13px] font-extrabold uppercase tracking-[0.12em] text-amber-700 md:text-[14px]" data-id="element-117" data-mp="mgwht3sppkcf">
        <FlameIcon className="h-4 w-4 shrink-0 fill-orange-400 text-orange-600" strokeWidth={2} aria-hidden data-id="element-118" data-mp="wd99xx8lzq52" />
        Oferta especial de lanzamiento
      </p>

      <div className="mx-auto mt-2 max-w-[512px] rounded-lg border-2 border-amber-400 bg-slate-50 px-3 pb-4 pt-3 md:px-4" data-id="element-119" data-mp="2t7m6u5u62l7d">
        <h2 className="text-[26px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-blue-950 md:text-[32px]" data-id="element-120" data-mp="12o1v5215z07i">
          ATLAS MIOFASCIAL™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] text-[12px] font-bold uppercase leading-[1.35] text-teal-700 md:text-[13px]" data-id="element-121" data-mp="xupa11vp1bji">
          La colección completa de rehabilitación miofascial.
        </p>

        <div className="mx-auto mt-2.5 max-w-[220px]" data-id="element-122" data-mp="ouaj9mzyn48m">
          <ProductImage data-id="element-123" data-mp="1llbc8cj0o1ll" />
        </div>

        <p className="mt-2 text-[13px] text-slate-600 md:text-[14px]" data-id="element-124" data-mp="1lka004q9l92a">Tu compra incluye:</p>
        <ul className="mx-auto mt-1.5 max-w-[400px] text-left text-[14px] leading-[1.5] text-slate-600 md:text-[15px]" data-id="element-125" data-mp="1gl6w4nm0t8vw">
          {offerItems.map(item => <CheckItem key={item} data-id="element-126" data-mp="17ljvi414873w">{item}</CheckItem>)}
        </ul>

        <p className="mt-4 text-[15px] font-extrabold uppercase text-blue-950 md:text-[17px]" data-id="element-127" data-mp="172fj9i6k38p">Todo por solo</p>
        <p className="text-[46px] font-extrabold leading-none tracking-[-1px] text-amber-500 md:text-[54px]" data-id="element-128" data-mp="3scklx31ia4y9">
          {formatPrice(PRODUCT_PRICE)}{' '}
          <span className="text-[18px] tracking-normal text-blue-950 md:text-[20px]" data-id="element-129" data-mp="3ts6jwp7s5me3">{PRODUCT_CURRENCY}</span>
        </p>

        <div className="mt-3" data-id="element-130" data-mp="3ktl431tp0lh0">
          <CtaButton mode="checkout" className="max-w-none min-h-[64px]" data-id="element-131" data-mp="3ks9rqdm6m5ea">
            ¡Quiero mi ATLAS MIOFASCIAL™!
          </CtaButton>
        </div>

        <p className="mx-auto mt-2.5 max-w-[420px] text-[11px] font-bold uppercase leading-snug text-blue-950 md:text-[12px]" data-id="element-132" data-mp="3owr5nw5v1oh5">
          {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-700" aria-hidden data-id="element-133" data-mp="3fvt2fg38xkzm" />}
          Acceso digital inmediato
          {guaranteeEnabled && <>
              {' '}
              <span className="text-amber-500" data-id="element-134" data-mp="3622h2k2f1qo5">·</span> Garantía de devolución de 7 días
            </>}
        </p>
      </div>
    </section>;
}